module.exports = __webpack_public_path__ + "static/img/logo09.a50dfa7e.png";